export const formTransactionSearchFields = {
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
  TRANSACTION_TYPE: 'transactionType',
  RECEIVER_ACCOUNT_NUMBER: 'receiverAccountId',
  SENDER_ACCOUNT_NUMBER: 'senderAccountId',
  FUEL_TYPE: 'biomethaneFuelType',
  CLEANING_TECHNOLOGY_TYPE: 'biomethaneTechnologyType',
  NUMBER: 'id',
  CURRENT_ACCOUNT_ID: 'currentAccountIds',
  GAS: 'gas',
  HYDROGEN_TYPE: 'hydrogenType',
  HYDROGEN_MANUFACTURING_TECHNOLOGY: 'hydrogenManufacturingTechnology',
};
